import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
// Material-UI
import Modal from '@material-ui/core/Modal';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
// Icons
import { X } from 'tabler-icons-react';
// Context
import { useCuenta } from './CuentaContext';

export default function EditContacto({ open, onClose }) {
    const { theUser, putUser } = useCuenta();
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');

    useEffect(() => {
        if (open) {
            setEmail(theUser.email || '');
            setPhone(theUser.phoneNumber || '');
        }
    }, [open, theUser]);

    const handleSave = () => {
        putUser({ ...theUser, email, phoneNumber: phone });
        onClose();
    };

    return (
        <Modal open={open} onClose={onClose}>
            <div className="cuenta-modal">
                <div className="cuenta-modal-header">
                    <h2 className="cuenta-modal-title">Editar información de contacto</h2>
                    <IconButton size="small" onClick={onClose}><X size={18} strokeWidth={2} /></IconButton>
                </div>
                <div className="cuenta-modal-body">
                    <TextField
                        label="Teléfono"
                        value={phone}
                        onChange={e => setPhone(e.target.value)}
                        fullWidth
                    />
                    <TextField
                        label="Correo electrónico"
                        type="email"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        fullWidth
                    />
                </div>
                <div className="cuenta-modal-footer">
                    <Button variant="outlined" className="usuarios-modal-cancel" onClick={onClose}>Cancelar</Button>
                    <Button variant="contained" color="primary" className="usuarios-modal-submit" onClick={handleSave}>
                        Guardar
                    </Button>
                </div>
            </div>
        </Modal>
    );
}

EditContacto.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};
